/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Public_Not_Found_DescInputs */

const vi_grower_area_public_not_found_desc = /** @type {(inputs: Grower_Area_Public_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã QR có thể đã cũ hoặc vùng trồng đã ngừng hoạt động.`)
};

/**

* @param {Grower_Area_Public_Not_Found_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_public_not_found_desc = /** @type {((inputs?: Grower_Area_Public_Not_Found_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Public_Not_Found_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_public_not_found_desc(inputs)
});